module.exports = __webpack_public_path__ + "img/recluse.22271ed9.png";